import { getPointer } from "libs/schema";
import { ActionServerContext } from "../action";
import { authorizeUserOwnership } from "./genericAuthorizers";

export async function authorizeUserCanUpdateNotifications(props: {
  notificationIds: string[];
  context: ActionServerContext;
}) {
  const { notificationIds, context } = props;

  await Promise.all(
    notificationIds.map((id) =>
      authorizeUserOwnership(getPointer("notification", id), context, {
        includeSoftDeletes: true,
        ignoreMissingRecord: true,
      }),
    ),
  );
}
